
export class Emisor {
    codigo: number;
    razonsocial: string;
    ruc: string;
    nomcomercial: string;
    direstablecimiento: string;
    codestablecimiento: string;
    codpintoemision: string;
    contribuyenteespecial: string;
    llevacontabilidad: string;
    logoimagen: string;
    direccionMatriz: string;
    token: string;
    preciosIva:string;
    descuento:string;
    etiqueta:string;
    reporteFactura:string;
    reporteNotaPedido:string;
    iva:number

    }
    